function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Close");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Hoivakotiportaali",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "iPhone-8---location-select",
  transform: "translate(-327.000000, -20.000000)",
  stroke: "#979797"
}, React.createElement("g", {
  id: "Close",
  transform: "translate(328.000000, 20.000000)"
}, React.createElement("line", {
  x1: 0.576923077,
  y1: 0.576923077,
  x2: 29.1331585,
  y2: 29.1331585,
  id: "Line-7"
}), React.createElement("line", {
  x1: 14.7012904,
  y1: -5.19230325,
  x2: 14.7217828,
  y2: 35.1923069,
  id: "Line-7",
  transform: "translate(14.711537, 15.000002) rotate(225.000000) translate(-14.711537, -15.000002) "
}))));

var SvgCloseX = function SvgCloseX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseX.4afd741e.svg";
export { ForwardRef as ReactComponent };